import { render } from "./section10.vue?vue&type=template&id=5ead584d&scoped=true"
const script = {}

import "./section10.vue?vue&type=style&index=0&id=5ead584d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead584d"]])

export default __exports__